import { useEffect, useRef } from "react"
import { useFrame } from "@react-three/fiber"
import io from "socket.io-client"

const CoordinatesBroadcaster = () => {
  const socket = useRef()

  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-camera", 1000)
  })

  useFrame(state => {
    if (role === "sender") {
      socket.current.emit("camera", {
        position: state.camera.position,
        rotation: state.camera.rotation
      })
    }
  })

  return null
}

CoordinatesBroadcaster.propTypes = {}

export default CoordinatesBroadcaster
